// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  min-height: 32px;
  border-radius: 20px;
  border: 1px solid var(--color-gray);
  background: var(--color-white);
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Urbanist', sans-serif;
  user-select: none;
  touch-action: manipulation;
}

.chip:hover:not(.disabled) {
  background: var(--color-light-gray);
  border-color: var(--color-dark-gray);
}

.chip.selected {
  background: var(--color-primary-green);
  border-color: var(--color-primary-green);
}

.chip.selected:hover:not(.disabled) {
  background: var(--color-dark-green);
  border-color: var(--color-dark-green);
}

/* Disabled state */
.chip.disabled {
  cursor: not-allowed;
  opacity: 0.6;
  background: var(--color-light-gray) !important;
  border-color: var(--color-gray) !important;
}

.chip.disabled:hover {
  background: var(--color-light-gray) !important;
  border-color: var(--color-gray) !important;
}

/* Typography color overrides for selected state */
.chip.selected .typography {
  color: var(--text-on-accent) !important;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .chip {
    padding: 8px 18px;
    min-height: 36px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Chip/Chip.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,mCAAmC;EACnC,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA,kDAAkD;AAClD;EACE,uCAAuC;AACzC;;AAEA,6BAA6B;AAC7B;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":[".chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 16px;\n  min-height: 32px;\n  border-radius: 20px;\n  border: 1px solid var(--color-gray);\n  background: var(--color-white);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: 'Urbanist', sans-serif;\n  user-select: none;\n  touch-action: manipulation;\n}\n\n.chip:hover:not(.disabled) {\n  background: var(--color-light-gray);\n  border-color: var(--color-dark-gray);\n}\n\n.chip.selected {\n  background: var(--color-primary-green);\n  border-color: var(--color-primary-green);\n}\n\n.chip.selected:hover:not(.disabled) {\n  background: var(--color-dark-green);\n  border-color: var(--color-dark-green);\n}\n\n/* Disabled state */\n.chip.disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n  background: var(--color-light-gray) !important;\n  border-color: var(--color-gray) !important;\n}\n\n.chip.disabled:hover {\n  background: var(--color-light-gray) !important;\n  border-color: var(--color-gray) !important;\n}\n\n/* Typography color overrides for selected state */\n.chip.selected .typography {\n  color: var(--text-on-accent) !important;\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  .chip {\n    padding: 8px 18px;\n    min-height: 36px;\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
